import { useState } from "react";
import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";
import ButtonX from "../Images/ButtonX.svg"
import Toast from '../Toast/Toast';

export default function ModalConsumoMinimo({ isOpen, onRequestClose }) {
  Modal.setAppElement('#root'); 
  const [list] = useState([]);
  const [isClose] = useState(false);
  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          if (isClose===true) {
            onRequestClose();
          }
        }}
        contentLabel="Modal"
        style={{ outline: 0 }}
        ariaHideApp={false}
        className={{
          base: "modal-base",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close"
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close"
        }}
        shouldCloseOnOverlayClick={true}
      >
          <div className="imgX" id="btnXModalGPCR" onClick={onRequestClose}><img alt={""} src={ButtonX}></img></div>
          <div className="modal-imgCheck"></div>
          <br />
          <div className="modalSubTitle">Seu cliente não possui consumo suficiente para assinar conosco</div>
      </Modal>
    </>
  )
}
